import type { OrdersFetchRequest, OrdersFetchResponse } from './types';

export async function fetchOrdersSection(
  request: OrdersFetchRequest,
  signal?: AbortSignal
): Promise<OrdersFetchResponse> {
  const response = await fetch(request.endpoint, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': request.nonce,
    },
    body: JSON.stringify({
      status: request.status,
      sort_option: request.sortOption,
      specific_date: request.specificDate,
      order_id: request.orderId,
      page: request.page,
    }),
    signal,
  });

  if (!response.ok) {
    throw new Error(`Orders request failed (${response.status})`);
  }

  const payload = (await response.json()) as OrdersFetchResponse;
  if (!payload || typeof payload.html !== 'string') {
    throw new Error('Invalid orders response payload.');
  }

  return payload;
}
